// extracted by mini-css-extract-plugin
export default {"main":"PanelInnerContainer_main__xAvz-"};